import { useQuery } from "@tanstack/react-query";
import { getDotdigitalStatus } from "../../api/bDotdigitalApi";

export const useGetDotdigitalStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["dotdigital-status", organisationId],
    queryFn: () => getDotdigitalStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
